export default __webpack_public_path__ + "static/media/BC19117-brass-builder.d6d53b94.jpg";